export const RoutePath = {
    DICT_MANAGE: '/dict/manage',
    LOG_OPERATION: '/log/operation',
    ACCOUNT_USER_LOGIN: '/account/user/login',
    ACCOUNT_USER_REGISTER: '/account/user/register',
    ACCOUNT_USER_PROFILE: '/account/user/profile',
    ACCOUNT_USER_SECURITY: '/account/user/security',
    ACCOUNT_TENANT_PROFILE: '/account/tenant/profile',
    ACCOUNT_TENANT_MEMBER: '/account/tenant/member',
    ACCOUNT_APP_ACTIVATED: '/account/app/activated',
    ACCOUNT_APP_MARKET: '/account/app/market',
    ACCOUNT_APP_MANAGE: '/account/app/manage',
    ACCOUNT_DATA_GROUP_MANAGE: '/account/data/group/manage',
    ACCOUNT_DEPARTMENT_MANAGE: '/account/department/manage',

    WORKFLOW_DEPUTY_LIST: '/workflow/deputy/list',

    // 邮件管理
    MAIL_PROPERTIES_LIST: "/mail/properties/list",
    MAIL_TEMPLATE_LIST: "/mail/template/list",

    // 微信管理
    WECHAT_APPLICATION_LIST: "/wechat/application/list",
    WECHAT_MESSAGE_TEMPLATE_LIST: "/wechat/message/template/list",

    VMS_VISITOR_REGISTER_INVITE_VISITOR: '/vms/visitor-register/invite/visitor',
    VMS_VISITOR_REGISTER_INVITE_CONSTRUCTION: '/vms/visitor-register/invite/construction',
    VMS_VISITOR_REGISTER_INVITE_SHIPPING: '/vms/visitor-register/invite/shipping',
    VMS_VISITOR_REGISTER_INVITE_SPECIAL_VEHICLE: '/vms/visitor-register/invite/special-vehicle',
    VMS_VISITOR_REGISTER_INVITE_EMPLOYEE_VEHICLE: '/vms/visitor-register/invite/employee-vehicle',
    VMS_VISITOR_REGISTER_HISTORY: '/vms/visitor-register/history',
    VMS_VISITOR_REGISTER_PENDING_REGISTER: "/vms/visitor-register/pending/register",
    VMS_VISITOR_REGISTER_PENDING_CHECKIN: "/vms/visitor-register/pending/checkin",
    VMS_VISITOR_MANAGE_CHECKIN: '/vms/visitor-manage/checkin',
    VMS_VISITOR_MANAGE_CHECKIN_SIGN: '/vms/visitor-manage/checkin/sign',
    VMS_VISITOR_MANAGE_HISTORY: '/vms/visitor-manage/history',
    VMS_VISITOR_MANAGE_HISTORY_VISITOR: '/vms/visitor-manage/history/visitor',
    VMS_VISITOR_MANAGE_HISTORY_CONSTRUCTION: '/vms/visitor-manage/history/construction',
    VMS_VISITOR_MANAGE_HISTORY_SHIPPING: '/vms/visitor-manage/history/shipping',
    VMS_VISITOR_MANAGE_BLACKLIST: '/vms/visitor-manage/blacklist',
    VMS_VISITOR_MANAGE_TODAY: '/vms/visitor-manage/today',
    VMS_VISITOR_CARD_LIST: '/visitor-manage/visitor/card/list',
    VMS_VISITOR_DEVICE_LIST: '/visitor-manage/visitor/device/list',
    VMS_SYSTEM_MANAGE_AREA: '/vms/system-manage/area',
    VMS_SYSTEM_MANAGE_VISITOR_TYPE: '/vms/system-manage/visitor/type',
    VMS_VISITOR_MANAGE_CHECKOUT: '/vms/visitor-manage/checkOut',

    VMS_VISITOR_MANAGE_HISTORY_NO_TENANT: '/vms/visitor-manage/historyNoTenant',

    EXOS_STAFF_QUERY: '/exos/staff/query',

    // 自助终端机画面
    VMS_SELF_TERMINAL_WELCOME: '/vms/self-terminal/welcome',
    VMS_SELF_TERMINAL_CHECKIN: '/vms/self-terminal/checkin',

    // 移动端画面
    VMS_MOBILE_WELCOME: '/vms/mobile/welcome',
    VMS_MOBILE_VISITOR_SELF_REGISTER: '/vms/mobile/visitor/self/register',
    VMS_MOBILE_EMPLOYEE_REGISTER: '/vms/mobile/employee/register',
    VMS_MOBILE_VISITOR_HISTORY: '/vms/mobile/visitor/history',

    VMS_MOBILE_EMPLOYEE_HOME: '/vms/mobile/employee/home',

    VMS_MOBILE_EMPLOYEE_LOGIN: '/vms/mobile/employee/login',
    VMS_MOBILE_EMPLOYEE_APPROVE: '/vms/mobile/employee/approve',
    VMS_MOBILE_EMPLOYEE_HISTORY: '/vms/mobile/employee/history',
}